import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const highlights = ['Desde cero, sin experiencia previa', 'Acceso inmediato y para siempre', 'Un solo pago de $11.990 ARS'];
export function Hero() {
  return <header className="relative overflow-hidden bg-cream" data-id="element-55" data-mp="4lysie31809y">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-linen" aria-hidden="true" data-id="element-56" data-mp="4jm4bj6oktog" />
      <div className="relative mx-auto grid max-w-6xl items-center gap-12 px-5 pb-16 pt-12 lg:grid-cols-2 lg:gap-16 lg:pb-24 lg:pt-20" data-id="element-57" data-mp="xae7j0m5yila">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-58" data-mp="sa9rfbp63pvl">
          <span className="inline-flex items-center gap-2 rounded-full border border-terracotta/30 bg-white/70 px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-terracotta" data-id="element-59" data-mp="3d2labedjz91r">
            Guía digital · Envío inmediato
          </span>

          <h1 className="mt-6 font-display text-4xl font-black leading-[1.08] text-ink sm:text-5xl lg:text-[3.2rem]" data-id="element-60" data-mp="3j6g1pzwctvil">
            Dejá de pelear con tutoriales confusos: Dominá la técnica Amigurumi y tejé tu primer
            muñeco profesional{' '}
            <span className="relative inline-block" data-id="element-61" data-mp="3e8egp9fdbm4h">
              <span className="relative z-10" data-id="element-62" data-mp="3eb91j22an8yf">en solo 7 días</span>
              <span className="absolute bottom-1 left-0 z-0 h-3 w-full bg-terracotta-light" aria-hidden="true" data-id="element-63" data-mp="30ggfdkrweuiv" />
            </span>
          </h1>

          <p className="mt-5 max-w-xl text-lg leading-relaxed text-muted" data-id="element-64" data-mp="2qk3kijkmaamj">
            El <strong className="font-bold text-ink" data-id="element-65" data-mp="2qi0kd6pr3143">Método Maestro</strong> es el sistema paso a
            paso para dominar el crochet, leer cualquier patrón y tejer muñecos perfectos, aunque
            nunca hayas tocado una aguja.
          </p>

          <ul className="mt-7 space-y-2.5" data-id="element-66" data-mp="2ljpaivzggqlv">
            {highlights.map(item => <li key={item} className="flex items-center gap-3 text-[15px] font-semibold text-ink" data-id="element-67" data-mp="s1rqqjt21ys6">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-sage/25 text-sage" data-id="element-68" data-mp="nbl2il2gggag">
                  <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-69" data-mp="ibgod1p0rxne" />
                </span>
                {item}
              </li>)}
          </ul>

          <div className="mt-9 max-w-lg" data-id="element-70" data-mp="db2fjhflgjob">
            <CtaButton href="#oferta" subLabel="Pago único · Garantía de 7 días · Acceso de por vida" data-id="element-71" data-mp="1b15o7bpztrnf" />
          </div>

          <div className="mt-7 flex items-center gap-3" data-id="element-72" data-mp="16344qponnqbf">
            <div className="flex text-terracotta" aria-hidden="true" data-id="element-73" data-mp="112g4ddejdx4j">
              {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-current" data-id="element-74" data-mp="x1ef9pec31ga" />)}
            </div>
            <p className="text-sm text-muted" data-id="element-75" data-mp="x3h6gcr830ml">
              <strong className="text-ink" data-id="element-76" data-mp="3lu026z6yb0yo">+500 tejedoras</strong> ya empezaron su primer muñeco
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.15,
        ease: 'easeOut'
      }} className="relative" data-id="element-77" data-mp="3htpy5s2pykmg">
          <div className="overflow-hidden rounded-[2rem] border-8 border-white shadow-soft" data-id="element-78" data-mp="268y4ph5tbx2z">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/40c2bcac-99a7-4a2e-972f-cdc32cebd405.jpg" alt="Amigurumis de conejo y oso tejidos a mano junto a ovillos de lana y una aguja de crochet" className="h-full w-full object-cover" data-id="element-79" data-mp="2b1ram8d0pbgn" />
          </div>
          <div className="absolute -bottom-5 left-4 rotate-[-3deg] rounded-2xl bg-white px-5 py-3 shadow-soft sm:left-8" data-id="element-80" data-mp="2p0qp4n6tg9z3">
            <p className="font-display text-xl font-black text-terracotta" data-id="element-81" data-mp="2tztr1yri202u">7 días</p>
            <p className="text-xs font-semibold uppercase tracking-wide text-muted" data-id="element-82" data-mp="umzfvosefs46">
              para tu primer muñeco
            </p>
          </div>
        </motion.div>
      </div>
    </header>;
}